import Logo from "./../media/logo.png";
import { Link, useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { FaChevronRight, FaChevronLeft, FaPowerOff } from "react-icons/fa";

const NAV_ITEMS = [
  { label: "Inicio",         path: "/dashboard",              exact: true },
  { label: "Seguimiento",    path: "/dashboard/seguimiento" },
  { label: "Cotizaciones",   path: "/dashboard/cotizaciones" },
  { label: "Entregadas",     path: "/dashboard/entregadas" },
  { label: "CRM",            path: "/dashboard/crm" },
  { label: "Procesos",       path: "/dashboard/procesos" },
  { label: "Administración", path: "/dashboard/admin" },
];

const DRAWER_W = 240;

const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const history  = useHistory();

  const isActive = (item) =>
    item.exact
      ? location.pathname === item.path
      : location.pathname.startsWith(item.path);

  const close = () => setOpen(false);

  const logOut = () => {
    if (window.confirm("¿Estás seguro de que deseas cerrar sesión?")) {
      axios
        .get(`${process.env.REACT_APP_API_BASE||"http://localhost/twinpack/php"}/logout.php`)
        .then(() => history.push("/"))
        .catch(() => alert("Hubo un error al cerrar sesión. Intenta de nuevo."));
    }
  };

  return (
    <>
      {/* ── Pestaña lateral (visible solo cuando el drawer está cerrado) ── */}
      {!open && (
        <button
          onClick={() => setOpen(true)}
          title="Abrir menú"
          style={{
            position: "fixed",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            width: 22,
            height: 64,
            background: "#9f0059",
            border: "none",
            borderRadius: "0 10px 10px 0",
            cursor: "pointer",
            zIndex: 300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "2px 2px 10px rgba(0,0,0,0.25)",
            padding: 0,
          }}
        >
          <FaChevronRight size={11} color="white" />
        </button>
      )}

      {/* ── Backdrop ── */}
      {open && (
        <div
          onClick={close}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.35)",
            zIndex: 200,
            backdropFilter: "blur(1px)",
          }}
        />
      )}

      {/* ── Drawer ── */}
      <aside
        style={{
          position: "fixed",
          top: 0,
          left: open ? 0 : -DRAWER_W - 10,
          width: DRAWER_W,
          height: "100vh",
          background: "#121212",
          zIndex: 250,
          display: "flex",
          flexDirection: "column",
          transition: "left 0.28s cubic-bezier(.4,0,.2,1)",
          boxShadow: open ? "4px 0 20px rgba(0,0,0,0.4)" : "none",
        }}
      >
        {/* Logo + botón cerrar */}
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #222",
          padding: "0 12px 0 0",
          flexShrink: 0,
        }}>
          <img
            src={Logo}
            alt="Twin Pack"
            style={{
              width: "100%",
              padding: "12px 20px",
              objectFit: "contain",
            }}
          />
          <button
            onClick={close}
            title="Cerrar menú"
            style={{
              background: "none",
              border: "none",
              color: "#777",
              cursor: "pointer",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              borderRadius: 6,
            }}
          >
            <FaChevronLeft size={15} />
          </button>
        </div>

        {/* Items de navegación */}
        <nav style={{ flex: 1, overflowY: "auto", paddingTop: 10, paddingBottom: 10 }}>
          {NAV_ITEMS.map((item) => {
            const active = isActive(item);
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={close}
                style={{
                  display: "block",
                  padding: "13px 24px",
                  color: active ? "#fff" : "#aaa",
                  background: active ? "rgba(159,0,89,0.2)" : "transparent",
                  borderLeft: active ? "3px solid #9f0059" : "3px solid transparent",
                  textDecoration: "none",
                  fontSize: 15,
                  fontWeight: active ? 600 : 400,
                  letterSpacing: "0.01em",
                  transition: "background 0.15s, color 0.15s",
                  whiteSpace: "nowrap",
                }}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        {/* Cerrar sesión */}
        <div style={{
          borderTop: "1px solid #222",
          padding: "14px 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexShrink: 0,
        }}>
          <span style={{ color: "#555", fontSize: 12 }}>Sesión activa</span>
          <button
            onClick={logOut}
            title="Cerrar sesión"
            style={{
              background: "none",
              border: "none",
              color: "#888",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontSize: 13,
              padding: "6px 8px",
              borderRadius: 6,
              transition: "color 0.2s",
            }}
          >
            <FaPowerOff size={13} />
            <span>Salir</span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default Header;
